function initCardSwatches() {
  const swatches = document.querySelectorAll('.card-swatch-wrapper .color-swatch');

  swatches.forEach(swatch => {
    if (swatch.dataset.swatchInit === 'true') return;
    swatch.dataset.swatchInit = 'true';

    swatch.addEventListener('click', event => {
      const colorSwatch = event.currentTarget;
      const card = colorSwatch.closest('.card-wrapper');
      if (!card) return;

      card.querySelectorAll('.card-swatch-wrapper .color-swatch.active')
          .forEach(active => active.classList.remove('active'));
      colorSwatch.classList.add('active');

      card.querySelectorAll('.ot-qatc-form .atc-vaiant-item.active-swatch')
          .forEach(active => active.classList.remove('active-swatch'));

      const color = colorSwatch.dataset.color;
      if (color) {
        card.querySelectorAll(`.ot-qatc-form .atc-vaiant-item[data-card-color="${color}"]`)
            .forEach(size => size.classList.add('active-swatch'));
      }

      const imgEl = card.querySelector('.card__media img');
      if (!imgEl) return;

      if (!card.dataset.originalImage) {
        card.dataset.originalImage = imgEl.src;
        card.dataset.originalSrcset = imgEl.srcset || '';
      }

      const variantImage = colorSwatch.dataset.variantImage;

      if (variantImage) {
        imgEl.src = variantImage;
        imgEl.srcset = `${variantImage} 165w, ${variantImage} 360w, ${variantImage} 533w, ${variantImage} 720w, ${variantImage} 940w, ${variantImage} 1066w, ${variantImage} 1920w`;
        imgEl.alt = color || 'Variant Image';
      } else {
        imgEl.src = card.dataset.originalImage;
        imgEl.srcset = card.dataset.originalSrcset;
      }

      const variantURL = colorSwatch.dataset.variantUrl;

      if (variantURL) {
        card.querySelectorAll('a').forEach( a => {
          a.href = `${card.dataset.cardUrl}?variant=${variantURL}`;
        });
        
      }
    });
  });
}

async function atcFormApi(form) {
  try {
    const cartSectionCartNotification = document.querySelector('cart-notification');
    const cartSectionCartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData(form);
    if (cartSectionCartNotification && cartSectionCartDrawer) {
      console.log('cart not',cartSectionCartNotification.getSectionsToRender(), section => section.id)
      console.log('cart drae',cartSectionCartDrawer.getSectionsToRender(), section => section.id)
      const cartNotificationArray = Array.from(cartSectionCartNotification.getSectionsToRender(), section => section.id)
      const cartDrawerArray = Array.from(cartSectionCartDrawer.getSectionsToRender(), section => section.id)
      const merged = [...new Set([...cartNotificationArray, ...cartDrawerArray])];
      formData.append('sections', merged);
   //   formData.append('sections', Array.from(cartSectionCartNotification.getSectionsToRender(), section => section.id));
    //  formData.append('sections', Array.from(cartSectionCartDrawer.getSectionsToRender(), section => section.id));
    } else if (cartSectionCartNotification) {
      const cartNotificationArray = Array.from(cartSectionCartNotification.getSectionsToRender(), section => section.id)
      formData.append('sections', cartNotificationArray);
    }
    console.log(' formData', formData)
    formData.append('sections_url', window.location.pathname)
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (!resp.ok) {
      throw new Error("Error While adding to cart")
    }

    const data = await resp.json();

    if (cartSectionCartNotification && cartSectionCartDrawer) {
      cartSectionCartNotification.renderContents(data);
      cartSectionCartDrawer.renderContents(data);
      if (cartSectionCartDrawer && cartSectionCartDrawer.classList.contains('is-empty')) cartSectionCartDrawer.classList.remove('is-empty');
      
      form.reset();
      document.body.classList.remove('overflow-hidden');
      if (document.querySelector('.atc-container.active') && document.querySelector('.atc-variant-container.active')) {
        document.querySelector('.atc-container.active').classList.remove('active');
        document.querySelector('.atc-variant-container.active').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }

      if (document.querySelector('.pdp-atc-container.active')) {
        document.querySelector('.pdp-atc-container.active').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    } else if (cartSectionCartNotification) {
        cartSectionCartNotification.renderContents(data);
              form.reset();
      document.body.classList.remove('overflow-hidden');
      if (document.querySelector('.atc-container.active') && document.querySelector('.atc-variant-container.active')) {
        document.querySelector('.atc-container.active').classList.remove('active');
        document.querySelector('.atc-variant-container.active').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }

      if (document.querySelector('.pdp-atc-container.active')) {
        document.querySelector('.pdp-atc-container.active').classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }

      setTimeout(() => {
        window.location.reload();
      }, 1250);

    }
  } catch (error) {
    document.body.classList.remove('overflow-hidden');
    if (document.querySelector('.atc-container.active') && document.querySelector('.atc-variant-container.active')) {
      document.querySelector('.atc-container.active').classList.remove('active');
      document.querySelector('.atc-variant-container.active').classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }

    if (document.querySelector('.pdp-atc-container.active')) {
      document.querySelector('.pdp-atc-container.active').classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
    console.log("Quick add to cart error!!!", error);
  }  
}

function handleAtcButtonClick(event) {
  event.preventDefault();
  const button = event.currentTarget;
  const currentWrapper = button.closest('.atc-btn-wrapper');
  const currentParentWrapper = button.closest('.atc-container');
  const currentCard = button.closest('.product-card-wrapper');
  if (!currentWrapper) return;

  document.querySelectorAll('.atc-variant-container.active,atc-container.active').forEach((wrapper) => {
    wrapper.classList.remove('active');
  });

  button.classList.add('active');

  const nextWrapper = currentWrapper.nextElementSibling;
  if (nextWrapper && nextWrapper.classList.contains('atc-variant-container') && nextWrapper.hasAttribute('data-only-variant')) {
    button.classList.remove('active');
    const atcForm = nextWrapper.querySelector('form');
    atcFormApi(atcForm);
    atcForm.reset();
  } else if (nextWrapper && nextWrapper.classList.contains('atc-variant-container') &&  currentParentWrapper &&  currentParentWrapper.classList.contains('atc-container')) {

  if (currentCard && window.innerWidth < 750) {
    document.body.classList.add('overflow-hidden');
  const mediaList = [...currentCard.querySelectorAll('.atc-variant-media [data-image]')];
  const selectedColorEl = currentCard.querySelector('.color-swatch.active');
  const targetWrapper = currentCard.querySelector('.atc-variant-images');
  console.log('selectedColorEl',selectedColorEl)
  console.log(' mediaList', mediaList)
  if (!selectedColorEl || !targetWrapper) return;

  const selectedColor = selectedColorEl.dataset.color;
console.log('selectedColor',selectedColor)
  const selectedMedia = mediaList.filter(img => img.dataset.alt === selectedColor);

  targetWrapper.innerHTML = '';

  console.log('selectedMedia',selectedMedia)
  selectedMedia.forEach(img => {
    const wrap = document.createElement('div');
    wrap.className = 'atc-variant-image';

    const newImg = document.createElement('img');
    newImg.src = img.getAttribute('data-image');
    newImg.alt = img.getAttribute('data-alt') || selectedColor;
 
    wrap.appendChild(newImg);
    console.log('wrap',wrap)
    targetWrapper.appendChild(wrap);
  });
}

    nextWrapper.classList.add('active');
    currentParentWrapper.classList.add('active');
  
    const atcForm = nextWrapper.querySelector('form');

    atcForm.addEventListener('input', (e) => {
      atcFormApi(atcForm);
      atcForm.reset();
    });     
  }
}

function initAtcButtons() {
  const buttons = document.querySelectorAll('.atc-btn-wrapper button.atc-btn');
  console.log('hello')
  if (!buttons.length) return; 

  buttons.forEach((btn) => {
    if (btn.dataset.atcBound === 'true') return;

    btn.dataset.atcBound = 'true';
    btn.addEventListener('click', handleAtcButtonClick);
  });
}

function mobilecloseButtons() {
  if (document.querySelector('.atc-container.active') && document.querySelector('.atc-variant-container.active')) {
    document.querySelector('.atc-container.active').classList.remove('active');
    document.querySelector('.atc-variant-container.active').classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

function initCloseBtns() {
  const closeBtns = document.querySelectorAll('.atc-variant-content-close');

  if (!closeBtns.length) return;

  closeBtns.forEach( btn => {
    if (btn.dataset.initClose === 'true') return;
    btn.dataset.initClose === 'true';
    btn.addEventListener('click', mobilecloseButtons);
  });
}

function handleProductCardMouseLeave() {
  if (window.innerWidth > 749 ) {
    const productCards = document.querySelectorAll('.card-wrapper');

    productCards.forEach(card => {
      if (card.dataset.mouseleaveInit === 'true') return;
      card.dataset.mouseleaveInit = 'true';

      card.addEventListener('mouseleave', () => {
        card.querySelectorAll('.atc-container,.atc-variant-container, .atc-btn').forEach(el => {
          el.classList.remove('active');
        });
      });
    }); 
  } else if (window.innerWidth < 750) {
    const sizeListOverlay = document.querySelectorAll('.card-wrapper .atc-container');
    
    sizeListOverlay.forEach( sizeWrap => {
      sizeWrap.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('atc-container') && evt.target.classList.contains('active')) {
          evt.currentTarget.querySelector('.atc-variant-container.active').classList.remove('active');
          evt.currentTarget.querySelector('.atc-btn.active').classList.remove('active');
          evt.currentTarget.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
        }
      });
    });  
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initCardSwatches();
  initAtcButtons(); 
  handleProductCardMouseLeave();
  initCloseBtns();
});
